// extracted by mini-css-extract-plugin
export default {"page":"blog_page__4sXUV","body":"blog_body__Wqm7y","pageTitleBar":"blog_pageTitleBar__FVxKm","pageTitleImage":"blog_pageTitleImage__a5vLF","pageTitle":"blog_pageTitle__cJf2L"};